import { useState } from "react"
import { Link } from "react-router-dom"
import { logout, useAuth } from "../lib/auth.js"
import { usePopover } from "../lib/usePopover.js"
import styles from "./AuthMenu.module.css"
import { LoginModal } from "./LoginModal.js"

export function AuthMenu() {
  const { user, isLoggedIn, isLoading } = useAuth()
  const { open, setOpen, rootRef } = usePopover<HTMLDivElement>()
  const [loginModalOpen, setLoginModalOpen] = useState(false)

  if (isLoading) return null

  if (!isLoggedIn) {
    return (
      <>
        <button
          type="button"
          className={styles.loginButton}
          onClick={() => setLoginModalOpen(true)}
        >
          ログイン
        </button>
        <LoginModal open={loginModalOpen} onClose={() => setLoginModalOpen(false)} />
      </>
    )
  }

  return (
    <div className={styles.root} ref={rootRef}>
      <button
        type="button"
        className={styles.trigger}
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label={user?.name ? `${user.name} のメニュー` : "アカウントメニュー"}
        onClick={() => setOpen((o) => !o)}
      >
        {user?.pictureUrl ? (
          <img
            src={user.pictureUrl}
            alt=""
            className={styles.avatar}
            referrerPolicy="no-referrer"
          />
        ) : (
          <span className={styles.avatarFallback} aria-hidden="true">
            {user?.name?.[0] ?? "?"}
          </span>
        )}
      </button>
      {open && (
        <div className={styles.menu} role="menu">
          {user?.name && <div className={styles.menuUserName}>{user.name}</div>}
          <Link
            to="/lists"
            className={styles.menuItem}
            role="menuitem"
            onClick={() => setOpen(false)}
          >
            マイリスト
          </Link>
          <button
            type="button"
            className={styles.menuItem}
            role="menuitem"
            onClick={() => {
              setOpen(false)
              logout()
            }}
          >
            ログアウト
          </button>
        </div>
      )}
    </div>
  )
}
